<template>
  <div class="page flexcolumn">
    <div class="jp-common-layout ">
      <div class="jp-common-layout-left" style="width: 370px;">
        <div class="jp-common-hearde mt8">
          <el-card class="box-card" style="width: 350px;">
            <div slot="header" class="clearfix" style="line-height: 20px;">
              <span class="fontbold fs14">客户基本信息</span>
            </div>
            <div>
              <el-form ref="form" :model="setsDetForm" label-width="90px">
                <el-form-item label="用户全名：">
                  <span class="fontbold">{{ setsDetForm.name }}</span>
                </el-form-item>
                <el-form-item label="邮箱：">
                  <span class="fontbold">{{ setsDetForm.email }}</span>
                </el-form-item>
                <el-form-item label="联系电话：">
                  <span class="fontbold">{{ setsDetForm.phone }}</span>
                </el-form-item>
                <el-form-item label="备注消息：">
                  <span class="fontbold">{{ setsDetForm.message }}</span>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </div>
        <div class="jp-common-title flexTreeTitle"> 
          <el-input
            placeholder="请输入关键字进行过滤"
            style="width: 245px;"
            size="small"
            clearable
            v-model="filterText">
          </el-input>
          <div>
            <el-button @click="searchTree('search')" size="small" type="primary" circle   icon="el-icon-search"></el-button>
            <el-button @click="searchTree('expandAll')" size="small" type="primary" circle   icon="fa fa-random"></el-button>
          </div>
        </div>
        <div class="jp-common-el-tree-scrollbar el-scrollbar">
          <div class="el-scrollbar__wrap" :style="{height: treeHeight-40 +'px',marginTop: '20px'}">
            <div class="el-scrollbar__view" style="">
                <vxe-table
                  show-overflow
                  :loading="treeLoading"
                  border="none"
                  ref="xTree"
                  :show-header="false"
                  :tree-config="{transform: true, rowField: 'id', parentField: 'parentId',expandAll: treeExpandAll,reserve:false,expandRowKeys: defaultExpandRowKeys}"
                  :radio-config="{labelField: 'nameCn'}"
                  :row-config="{keyField:'id',isCurrent: true, isHover: true}"
                  :data="showTreeList">
                  <vxe-column field="nameCn" tree-node>
                    <template slot-scope="scope">
                      <div style="width: 100%;" @click="handRow(scope.row, 'row')">{{ scope.row.nameCn }}（{{scope.row.count }}）</div>
                    </template>
                  </vxe-column>
                  <vxe-column  title="操作" width="40" style="margin-left: 0px;">
                    <template #default="{ row, rowIndex, $rowIndex, column}">
                      <!-- <i v-if="row.grade =='2'"  @click.stop="editTree(row)" class="el-icon-edit-outline"></i> -->
                      <!-- <i @click.stop="editTree(row)" class="el-icon-edit-outline"></i> -->
                    </template>
                  </vxe-column>
                </vxe-table>
            </div>
          </div>
        </div>
      </div>
      <div class="jp-common-layout-center jp-flex-main">
        <div class="pd8 spaceMessage" >
          <el-card class="box-card" style="width: 100%;">
              <div slot="header" class="clearfix" style="line-height: 20px;">
                <span class="fontbold fs14">客户选择的空间信息：</span>
              </div>
              <div v-for="msg in spaceDet.userSpaceList" :key="msg.id" class="mt8 mb8"> 
                <el-col :span="12" class="mb8">
                  <span class="fs14">{{ msg.functionSpaceOjb.nameCn }}：{{ msg.nameCn }}</span>
                  <!-- <span class="fs14 ml32">{{ msg.functionSpaceOjb.nameEn }} （英）：{{ msg.nameEn }}</span> -->
                  <!-- <span class="fs14">{{ msg.functionSpaceOjb.nameCn }} （中）：{{ msg.nameCn }}</span>
                  <span class="fs14 ml32">{{ msg.functionSpaceOjb.nameEn }} （英）：{{ msg.nameEn }}</span> -->
                </el-col>
              </div>
          </el-card>
        </div>
        <!-- <div class="spaceMessage ">
          <div>
            <span class="fontbold fs14">客户选择的空间信息：</span>
          </div>
          <el-row>
            <div v-for="msg in spaceDet.userSpaceList" :key="msg.id" class="mt8 mb8"> 
              <el-col :span="12" class="mb8">
                <span class="fs14">{{ msg.functionSpaceOjb.nameCn }}：{{ msg.nameCn }}</span>
              </el-col>
            </div>
          </el-row>
        </div> -->

        <div class="bg-white top">
          <div style="height: calc(100% - 40px);">
            <vxe-table
              border="full"
              auto-resize
              resizable
              height="100%"
              :loading="loading"
              size="small"
              ref="cecUnmSetsProjectTable"
              show-header-overflow
              show-overflow
              highlight-hover-row
              :menu-config="{}"
              :print-config="{}"
              :import-config="{
              importMethod: importMethod,
                  types: ['csv', 'xls', 'xlsx'],
                  remote: true,
              }"
              :export-config="{
                  remote: true,
                  filename: `空间表数据${moment(new Date()).format(
                  'YYYY-MM-DD'
                  )}`,
                  sheetName: '空间表数据',
                  exportMethod: exportMethod,
                  types: ['xlsx'],
                  modes: ['current', 'selected', 'all'],
              }"
              @sort-change="sortChangeHandle"
              :sort-config="{remote:true}"
              :data="dataList"
              :checkbox-config="{}">
              <!-- <vxe-column type="checkbox"  width="40px" align="center" fixed="left"></vxe-column> -->
            <vxe-column type="seq" width="50" fixed="left" align="center" title="序号"></vxe-column>
            <!-- <vxe-column
        field="isFinish"
        fixed="left"
        align="center"
        width="80"
        title="配置状态">
        <template slot-scope="scope">
          <i v-if="scope.row.project.isFinish == '1'" class="el-icon-check isFinishIcon colorGreen" ></i>
          <i v-else class="el-icon-close isFinishIcon colorRed" ></i>
        </template>
      </vxe-column> -->
      <vxe-column
        field="proCode"
        fixed="left"
        align="center"
        width="100"
        title="项目编号">
              <template slot-scope="scope">
                <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmprojectpositionproject:cecUnmProjectPositionProject:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
                <el-link  type="primary" :underline="false" v-if="hasPermission('cecunmusersetmeal:cecUnmUserSetMeal:view')"  @click="view(scope.row)">{{scope.row.project.proCode}}</el-link>
                <span v-else>{{scope.row.project.proCode}}</span>
              </template>
      </vxe-column>
      <vxe-column
        field="name"
        fixed="left"
        align="center"
        width="150"
        title="项目名称">
        <template slot-scope="scope">
          <span>{{ scope.row.project.name }}</span>
        </template>
      </vxe-column>
      <vxe-column
        field="kindName1"
        width="150"
        align="center"
        title="工程类别">
        <template slot-scope="scope">
          <span>{{ scope.row.project.kindName1 }}</span>
        </template>
      </vxe-column>
    <vxe-column
        field="kindName2"
        width="150"
        align="center"
        title="工程类型">
        <template slot-scope="scope">
          <span>{{ scope.row.project.kindName2 }}</span>
        </template>
      </vxe-column>
      <vxe-column
          field="storeyId"
          align="center"
          width="100"
          title="楼层">
          <template slot-scope="scope">
          <span>{{ scope.row.storey ? scope.row.storey.nameCn : '' }}</span>
        </template>
        </vxe-column>
      <vxe-column
          field="roomId"
          align="center"
          width="100"
          title="空间">
          <template slot-scope="scope">
          <span>{{ scope.row.room ? scope.row.room.nameCn : '' }}</span>
        </template>
        </vxe-column>
      <vxe-column
          field="positionId"
          align="center"
          width="150"
          title="位置">
          <template slot-scope="scope">
          <span>{{ scope.row.position ? scope.row.position.nameCn : '' }}</span>
        </template>
        </vxe-column>
      <vxe-column
          field="num"
          align="center"
          width="100"
          title="数量/面积">
        </vxe-column>
        <vxe-column
          field="unitId"
          align="center"
          width="100"
          title="单位">
          <template slot-scope="scope">
            <span>{{ scope.row.project.unit ? scope.row.project.unit.unitEn : '' }}</span>
          </template>
        </vxe-column>
      <vxe-column
          field="price"
          align="center"
          width="100"
          title="项目单价">
          <template slot-scope="scope">
            <div class="flexBetween">
              <span>$</span>
              <span>{{  $mathUtil.mathToFixed(scope.row.price) }}</span>
            </div>
          </template>
        </vxe-column>
      <vxe-column
          field="totalPrice"
          align="center"
          width="100"
          title="项目总价">
          <template slot-scope="scope">
            <div class="flexBetween">
              <span>$</span>
              <span>{{  $mathUtil.mathToFixed(scope.row.totalPrice) }}</span>
            </div>
          </template>
        </vxe-column>
      <vxe-column
          field="description"
          align="center"
          min-width="100"
          title="备注">
        </vxe-column>
      <!-- <vxe-column
          field="makeupId"
          align="center"
          width="100"
          title="材料方案id">
        </vxe-column>
        <vxe-column
          field="linkProjectId"
          align="center"
          width="100"
          title="关联项目">
        </vxe-column> -->
            <!-- <vxe-column
              fixed="right"
              align="center"
              width="200"
              title="操作">
              <template  slot-scope="scope">
                <el-button v-if="hasPermission('unmspace:cecUnmSpace:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button>
                <el-button v-if="hasPermission('unmspace:cecUnmSpace:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button>
                <el-button v-if="hasPermission('unmspace:cecUnmSpace:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button>
              </template>
            </vxe-column> -->
          </vxe-table>
          <vxe-pager
            background
            size="small"
            :current-page="tablePage.currentPage"
            :page-size="tablePage.pageSize"
            :total="tablePage.total"
            :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="currentChangeHandle">
          </vxe-pager>
        </div>
        </div>
          <!-- 弹窗, 新增 / 修改 -->
        <CecUnmSetsTreeForm  ref="CecUnmSetsTreeFormRef" @refreshDataList="refreshList"></CecUnmSetsTreeForm>
      </div>
    </div>
  </div>
</template>

<script>
  // import CecUnmSpaceForm from './CecUnmSpaceForm'
  import GridSelect from '@/components/gridSelect/setTagTableSet.vue'
  import PopoverTip from '@/components/popoverTip'
  import PopoverTipList from '@/components/popoverTip/indexList.vue'
  import cecUnmUserSetMealService from '@/api/cecunmusersetmeal/cecUnmUserSetMealService'
  import cecProjectKindService from '@/api/cecprojectkind/cecProjectKindService'
  import CecUnmSetsTreeForm from './CecUnmUserSetsTreeForm'
  import SetMealPositionService from '@/api/cecunmusersetmealposition/cecUnmUserSetMealPositionService'
  import csmpProjectService from '@/api/cecunmusersetmealproject/cecUnmUserSetMealProjectService'
  export default {
    data () {
      return {
        searchForm: {
          nameEn: '',
          name: '',
          projectIdsStr: '',
          spaceIdsStr: '',
          type: '',
          storeyId: '',
          roomId: '',
          positionId: '',
          proCode: '',
          kindId1: '',
          kindId2: ''
        },
        setsDetForm: {
          name: '',
          email: '',
          phone: '',
          message: ''
        },
        oldRow: null,
        spaceDet: {
          userSpaceList: []
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'a.create_date', asc: true }]
        },
        loading: false,
        treeLoading: false,
        filterText: '',
        officeTreeData: [],
        showTreeList: [],
        projectSetsId: '',
        clearRow: false,
        treeHeight: '',
        treeExpandAll: false,
        storeyValue: '',
        roomValue: '',
        positionValue: '',
        kindCategoriesList: [],
        kindTypeList: [],
        defaultExpandRowKeys: [],
        spaceTreeIdsNew: '',
        spaceTreeIdsOld: '',
        spaceListIdsNew: ''
      }
    },
    components: {
      GridSelect,
      PopoverTip,
      PopoverTipList,
      CecUnmSetsTreeForm
    },
    activated () {
      // this.clearSearchData()
      this.projectSetsId = this.$route.query.id
      this.$nextTick(() => {
        this.getProjectKind('Categories', '0')
        this.getSetsProject()
        this.getTreeList()
        this.treeHeight = document.getElementsByClassName('jp-common-el-tree-scrollbar')[0].offsetHeight
      })
    },
    watch: {
      // storeyValue (val) {
      //   let findPositionData = this.officeTreeData.find(item => item.dictValueId === val)
      //   this.searchForm.storeyId = findPositionData ? findPositionData.id : val
      // }
      projectSetsId (val) {
        if (val !== '') {
          this.clearRow = true
        }
      }
    },
    methods: {
      isSelectedChange (data) {
        this.loading = true
        let query = {
          id: data.id,
          isSelected: data.isSelected
        }
        csmpProjectService.save(query).then(({data}) => {
          this.$message.success(data)
          this.refreshList()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 点击树编辑
      editTree (e) {
        this.$refs.CecUnmSetsTreeFormRef.init('edit', e.id)
      },
      // 获取工程类型和类别
      getProjectKind (type, pid) {
        cecProjectKindService.getKindList(
          {
            parentId: pid,
            orders: [{ column: 'sort', asc: true }]
          }
        ).then(({data}) => {
          if (type === 'Categories') {
            this.kindCategoriesList = data
          } else {
            this.kindTypeList = data
          }
        })
      },
      // 获取套餐详情
      getSetsProject () {
        cecUnmUserSetMealService.queryById(this.projectSetsId).then(({data}) => {
          this.setsDetForm = data
        })
      },
      // 点击树结构
      handRow (row, type) {
        this.oldRow = row
        this.spaceDet = row
        if (row.grade === '1') {
          this.searchForm.storeyId = row.id
          this.searchForm.roomId = ''
          this.storeyValue = row.dictValueId
          this.roomValue = ''
          this.positionValue = ''
          this.searchForm.positionId = ''
        } else if (row.grade === '2') {
          this.storeyValue = ''
          this.searchForm.roomId = row.id
          this.roomValue = row.dictValueId
          this.positionValue = ''
          this.searchForm.positionId = ''
        } else {
          // let gradeTwoData = this.officeTreeData.find(item => item.id === row.id)
          this.storeyValue = ''
          this.searchForm.storeyId = ''
          this.roomValue = ''
          this.searchForm.roomId = ''
          this.searchForm.positionId = row.id
          this.positionValue = row.dictValueId
        }
        // if (type === 'row') {
        this.refreshList()
        // }
      },
      // 展开和搜索树结构
      searchTree (type) {
        if (type === 'expandAll') {
          this.treeExpandAll = !this.treeExpandAll
          this.$refs.xTree.setAllTreeExpand(this.treeExpandAll)
        } else if (type === 'search') {
          let parentList = []
          if (this.filterText) {
            let filerData = this.officeTreeData.filter(item => item.nameCn.indexOf(this.filterText) >= 0)
            filerData.forEach(item => {
              let findDate = this.officeTreeData.find(fitem => fitem.id === item.parentId)
              if (findDate) {
                parentList.push(findDate)
              }
            })
            let filterList = [...filerData, ...parentList]
            this.showTreeList = filterList
            this.$refs.xTree.setAllTreeExpand(true)
          } else {
            this.showTreeList = this.officeTreeData
          }
        }
      },
      filterNode (value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },
      renderContent (h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span class="text">{node.label}</span>
          </span>
        )
      },
      handleNodeClick (data) {
        if (data.id === '') {
          this.searchForm.type = ''
        } else {
          this.searchForm.type = data.id
        }
        this.refreshList()
      },
      // 获取树结构
      getTreeList (type) {
        this.treeLoading = true
        if (this.clearRow) {
          this.oldRow = null
          this.clearRow = false
        }
        SetMealPositionService.allList({
          userSetsId: this.projectSetsId,
          orders: [{ column: 'sort', asc: true }]
        }).then(({data}) => {
          this.officeTreeData = data
          let filterList = data.filter(item => item.parentId === '0')
          if (filterList.length === 1) {
            this.defaultExpandRowKeys.push(filterList[0].id)
          }
          this.$nextTick(() => {
            // this.showTreeList = data
            this.$refs.xTree.reloadData(data)
            if (data.length === 1 || data.length > 1) {
              if (!this.oldRow) {
                this.defaultExpandRowKeys.push(data[0].id)
                this.$refs.xTree.setCurrentRow(data[0])
                this.spaceDet = data[0]
                this.handRow(data[0])
              } else {
                let dataFind = data.find(item => item.id === this.oldRow.id)
                let defaultExpandRowKeysIds = this.oldRow.parentId === '0' ? [this.oldRow.id] : [this.oldRow.parentId, this.oldRow.id]
                this.defaultExpandRowKeys = defaultExpandRowKeysIds
                this.$refs.xTree.setCurrentRow(dataFind)
                this.spaceDet = dataFind
                this.handRow(this.oldRow)
              }
            }
            this.treeExpandAll = true
          })
          this.spaceTreeIdsNew = data.length > 0 ? data.map(item => item.id).join(',') : ''
          this.spaceTreeIdsOld = data.length > 0 ? data.map(item => item.id).join(',') : ''
          this.treeLoading = false
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        csmpProjectService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          userSetsId: this.projectSetsId,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.spaceListIdsNew = data.records.length > 0 ? data.records.map(item => item.id).join(',') : ''
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmProjectPositionProjectForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmSetsProjectTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmProjectPositionProjectForm.init('edit', id)
      },
      // 查看
      view (data) {
        // this.$refs.cecUnmProjectPositionProjectForm.init('view', uid)
        this.$router.push({path: '/cecunmusersetmeal/CecUnmUserSetsMealProjectDet', query: {id: data.id, title: '套餐' + data.proCode + '<详情>'}})
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmSetsProjectTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          csmpProjectService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        csmpProjectService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        csmpProjectService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return csmpProjectService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      clearSearchData () {
        this.$refs.searchForm.resetFields()
        this.roomValue = ''
        this.storeyValue = ''
        this.positionValue = ''
        this.defaultExpandRowKeys = []
        // this.showTreeList = []
        // this.oldRow = null
      },
      resetSearch () {
        this.clearSearchData()
        if (!this.handRow === false) {
          this.handRow(this.oldRow)
        } else {
          this.refreshList()
        }
      }
    }
  }
</script>
<style scoped >
::v-deep .jp-common-layout-left .vxe-body--column{
  height: 35px !important;
  cursor: pointer;
}
.jp-common-hearde{
    /* padding: 10px; */
    background-color: #fff;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-bottom: 10px;
}
.flexcolumn{
  display: flex;
  flex-direction: column;
}
::v-deep .jp-common-layout .el-card__header {
    padding: 10px 20px !important;
}
::v-deep .jp-common-layout .el-form-item__label {
    line-height: 22px;
}
::v-deep .jp-common-layout .el-form-item__content {
    line-height: 22px;
}
::v-deep .jp-common-layout .el-form-item {
    margin-bottom: 0;
}
::v-deep .jp-common-layout .el-form-item label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: bold;
}
::v-deep .jp-common-layout .el-card__body {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
.fontbold{
  font-weight: bold;
}
.fs14{
  font-size: 14px;
}
.flexTreeTitle{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .el-scrollbar__view  .vxe-body--row.row--current {
    background-color: #ffd991 !important;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.spaceMessage {
  padding: 10px 20px;
  background-color: white;
  margin-bottom: 10px;
}
</style>
